import firebase from "firebase"

export const generateId = () => firebase.firestore().collection("/foo").doc().id
